import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { centralWarehouseInventoryRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const centralWarehouseInventoryRouteMetadata: IRouteMetadataObj<
  typeof centralWarehouseInventoryRoutesObj
> = {
  list: {
    title: "warehouseManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/centralWarehouseInventory/table/page"),
    mode: "index",
    type: "main",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "warehouseManagement.centralWarehouseInventory.create.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/addNewItem/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "warehouseManagement.viewAndEditItem.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/addNewItem/editItem/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  viewItemInventory: {
    title: "warehouseManagement.viewItemInventory.title",
    description: "empty",
    lazy: () =>
      import("src/pages/warehouseManagement/viewItemInventory/table/page"),
    mode: "view",
    type: "inner",
    icon: "NumbersLine",
    breadcrumbs: [],
    permission,
  },
  warehouseEntry: {
    title: "warehouseManagement.warehouseEntry.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/warehouseEntry/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  warehouseExit: {
    title: "warehouseManagement.warehouseExit.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/warehouseExit/form/page"),
    mode: "create",
    type: "inner",
    icon: "SubtractLine",
    breadcrumbs: [],
    permission,
  },
  sendToScrapWarehouse: {
    title: "warehouseManagement.sendToScrapWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/sendToScrapWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "DeleteBin2Line",
    breadcrumbs: [],
    permission,
  },
  returnFromScrapWarehouse: {
    title: "warehouseManagement.returnFromScrapWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/returnFromScrapWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "RestartLine",
    breadcrumbs: [],
    permission,
  },
  transferToSalesWarehouse: {
    title: "warehouseManagement.transferToSalesWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/transferToSalesWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "ArrowLeftRightLine",
    breadcrumbs: [],
    permission,
  },
};

export const centralWarehouseInventoryRoutes = createRoute<
  typeof centralWarehouseInventoryRoutesObj
>(centralWarehouseInventoryRoutesObj, centralWarehouseInventoryRouteMetadata);
